import { useState } from 'react';
import { httpClient } from '../api/http';
import { Alert } from '@piggytechng/component-library';
import { BulkFlagRow } from '../types';

const useBulkFlag = () => {
  const [isFlagging, setIsFlagging] = useState(false);
  const [isUnflagging, setIsUnflagging] = useState(false);

  const flagUsersInBulk = async (rows: BulkFlagRow[], callback?: () => void) => {
    try {
      setIsFlagging(true);
      const response: any = await httpClient.post('admin/user/flag-users-in-bulk', rows);
      if (response.data.status) {
        Alert.success(response.data.data?.message || response.data.message || 'Users flagged successfully');
        callback?.();
        return response.data;
      }
      Alert.error(response.data.message || 'Failed to flag users');
    } catch (error: any) {
      Alert.error(error?.response?.data?.message || 'Failed to flag users');
    } finally {
      setIsFlagging(false);
    }
  };

  const unblacklistUsers = async (users: string[], callback?: () => void) => {
    try {
      setIsUnflagging(true);
      const response: any = await httpClient.post('admin/user/unblacklist-users', { users });
      if (response.data.status) {
        Alert.success(response.data.message || 'Users unflagged successfully');
        callback?.();
        return response.data;
      }
      Alert.error(response.data.message || 'Failed to unflag users');
    } catch (error: any) {
      Alert.error(error?.response?.data?.message || 'Failed to unflag users');
    } finally {
      setIsUnflagging(false);
    }
  };

  return { flagUsersInBulk, unblacklistUsers, isFlagging, isUnflagging };
};

export default useBulkFlag;
